import type { z } from "zod";
import { NoAuthError } from "@utils/NoAuthError";
import { RouterOutputs, trpc } from "@utils/trpc";
import { getQueryKey } from "@trpc/react-query";
import { followingsListSchema } from "@libs/wire";
import type { DataSession } from "../../../data/core/session";

export type FollowingsQueryData =
  RouterOutputs["user"]["artistSubscriptions"]["listItems"];

/**
 * Compile-time drift check, bidirectional. See useLibrary/queryFunctions.ts
 * for the full rationale.
 */
type _FollowingsWireSchemaSubset =
  z.infer<typeof followingsListSchema> extends FollowingsQueryData
    ? true
    : never;
type _FollowingsWireSchemaSuperset =
  FollowingsQueryData extends z.infer<typeof followingsListSchema>
    ? true
    : never;
const _followingsWireSchemaDriftCheck: [
  _FollowingsWireSchemaSubset,
  _FollowingsWireSchemaSuperset,
] = [true, true];
void _followingsWireSchemaDriftCheck;

export const followingsQueryKey = () =>
  getQueryKey(trpc.user.artistSubscriptions.listItems);

export const followingsQuery = (data: DataSession) =>
  data.cache.durableQueryOptions({
    queryKey: followingsQueryKey(),
    queryFn: () => {
      if (!data.auth.currentUser()) {
        throw new NoAuthError("followingsQuery queryFn");
      }
      return data.api.user.artistSubscriptions.listItems.query();
    },
    schema: followingsListSchema,
  });
